var React = require('react');

function TriangleTop (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"Top-Shape","points":"0 -6.06546063e-15 1600 -6.06546063e-15 400 60","fill":"#91D1D8"}));
}

TriangleTop.defaultProps = {"viewBox":"0 0 1600 60","version":"1.1"};

module.exports = TriangleTop;

TriangleTop.default = TriangleTop;
